export const stripLocale = (path: string) => {
  return path.replace(/^\/[a-z]{2}-[A-Z]{2}(?:\/|$)/, '/');
};
